module.exports = __webpack_public_path__ + "static/theo-and_our_clients@1x-b2da886c4dc619e34daa78fc16a364ef.png";